<!-- BOM匹配详情弹框 -->
<template>
  <el-dialog 
    title="BOM匹配结果" 
    append-to-body
    custom-class="bom-item-dialog full-screen-dialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible="isShow" 
    @close="close"
  >
    <div  class="bom-item-dialog__content">
      <bom-result v-if="oneStopBomId" :oneStopBomId = "oneStopBomId"></bom-result>
    </div>
  </el-dialog>
</template>

<script>
import bomResult from "./bomResult.vue";
export default {
  components: {
    bomResult
  },
  data() {
    return {
      oneStopBomId :null,
      isShow: false,
    }
  },
  methods: {
    open(bomId) {
      this.oneStopBomId = bomId
      this.isShow = true
    },
    close() {
      this.isShow = false
    },

  }
}
</script>

<style lang="scss" scoped>
::v-deep .bom-item-dialog {
  $barderColor: #d7d7d7;
  position: fixed !important;
  top: 80px !important;
  left: 80px !important;
  right: 80px !important;
  bottom: 80px !important;
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
  display: flex;
  flex-direction: column;
  .bom-item-dialog__content,.smt-bom-result{
    height: 100%;
  }
 
  .el-dialog {
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
  }

  .el-dialog__header {
    flex-shrink: 0;
    padding: 20px 30px 0 30px;
  }


  .el-dialog__header .el-dialog__title {
    font-weight: 700;
    color: $--color-text-primary;
  }

  .el-dialog__body {
    flex: 1;
    overflow: auto;
    min-height: 0;
    padding: 18px 30px 30px;
  }

  .el-dialog__footer {
    flex-shrink: 0;
    padding: 0 20px 20px 20px;
  }
}
</style>